import { defineStore } from 'pinia'
import { api } from '@/api/axios'
import { useCajaStore } from './cajaStore'
import {
  setToken,
  getToken,
  removeToken,
  setRefreshToken,
  removeRefreshToken,
  setUser,
  removeUser
} from '@/utils/tokenStorage'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    appReady: false,
    isAuthenticated: !!getToken(),
    isTurnosOnly: false
  }),
  actions: {
    setAppReady(value) {
      this.appReady = value
    },
    async login(credentials) {
      try {
        const response = await api.post('/auth/login', credentials)
        // console.log('response', response)
        const { user, token, refresh_token, turno, caja_id } = response.data

        // Verificar si el usuario solo tiene permiso de turnos
        const isTurnosOnly = this.checkIsTurnosOnly(user)

        this.user = { ...user, turno, caja_id }
        this.isTurnosOnly = isTurnosOnly
        this.isAuthenticated = true

        setUser(JSON.stringify({ ...this.user, isTurnosOnly }))
        setToken(token)
        setRefreshToken(refresh_token)

        // console.log('Usuario autenticado:', {
        //   user: this.user,
        //   isTurnosOnly: this.isTurnosOnly
        // })

        // Llamar a getLastCaja después del login exitoso
        const cajaStore = useCajaStore()
        await cajaStore.getLastCaja()

        return this.isTurnosOnly
      } catch (error) {
        console.error('Login failed:', error)
        throw error
      }
    },

    // Método para verificar si el usuario solo tiene permiso de turnos
    checkIsTurnosOnly(user) {
      // Verificar si el usuario solo tiene el permiso "turnos"
      return (
        user.permiso &&
        user.permiso.includes('turnos') &&
        user.permiso.length === 1
      )
    },

    async logout() {
      try {
        await api.delete('/auth/logout')
      } catch (error) {
        console.error('Logout failed:', error)
      } finally {
        this.user = null
        this.isAuthenticated = false
        this.isTurnosOnly = false
        console.error('Logout!!!!!:')
        removeUser()
        removeToken()
        removeRefreshToken()
      }
    },

    async fetchUser() {
      try {
        const response = await api.get('/auth/user')
        const { user, turno, caja_id } = response.data

        // Verificar si el usuario solo tiene permiso de turnos
        const isTurnosOnly = this.checkIsTurnosOnly(user)

        this.user = { ...user, turno, caja_id }
        this.isTurnosOnly = isTurnosOnly
        this.isAuthenticated = true

        setUser(JSON.stringify({ ...this.user, isTurnosOnly }))

        console.log('Usuario cargado:', {
          user: this.user,
          isTurnosOnly: this.isTurnosOnly
        })

        // // Si es usuario de solo turnos, redirigir
        // if (this.isTurnosOnly) {
        //   console.log('Redirigiendo a usuario de solo turnos desde fetchUser')
        //   window.location.href = '/turnos/ver-turnos'
        // }

        return this.isTurnosOnly
      } catch (error) {
        console.error('Fetching user failed:', error)
        this.logout()
        throw error
      }
    },

    async updateTurnoFromIdentity(turno) {
      console.log('updateTurnoFromIdentity', this.user, turno)
      this.user = { ...this.user, turno }
      setUser(JSON.stringify({ ...this.user, isTurnosOnly: this.isTurnosOnly }))
    }
  }
})
